import React, { useEffect } from "react";
import { Select, ConfigProvider } from "antd";
import SC from "./style";
const { Option } = Select;

const DropdownWithSearch = (props) => {
  const {
    defaultValue,
    placeholder,
    options,
    onChange,
    onAddNew,
    optionFilterProp = "children",
    width = "340px",
    height = "29px",
    newItemLabel = "+ Add New",
    disabled = false,
    theme = { colors: { bordertask: "#ccc" } },
    dropdowType = "",
    disabledDropdown = false,
    maxTagCount = 4,
    allowClear = false,
    defaultOpen = false,
  } = props;

  // Ensure the selected value is valid, otherwise reset it to null

  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "#E36E00", // Updated to new theme color
          colorBorder: theme.colors.bordertask, // Dynamic border color
          colorText: "#374151", // Better text color
          colorTextPlaceholder: "rgba(55, 65, 81, 0.6)", // Better placeholder color
          borderRadius: 8, // Modern border radius
          controlHeight: 40, // Consistent height
        },
      }}
    >
      {SC.Globalstyles}
      <Select
        allowClear={allowClear}
        onMouseDown={(e) => e.stopPropagation()} // Prevent Drawer from closing
        onTouchStart={(e) => e.stopPropagation()}
        showSearch
        value={defaultValue}
        disabled={disabledDropdown}
        defaultOpen={defaultOpen}
        onChange={onChange}
        getPopupContainer={(triggerNode) => triggerNode.parentNode}
        className="custom-select" // Add a custom class name
        style={{
          width: width,
          height: height,
          textAlign: "left",
          cursor: "pointer",
        }}
        popupMatchSelectWidth={false}
        dropdownStyle={{ minWidth: width, maxWidth: 400 }}
        listHeight={280}
        placeholder={placeholder}
        required
        optionFilterProp={optionFilterProp}
        maxTagCount={maxTagCount}
        filterOption={(input, option) => {
          const search = (input || "").toLowerCase().trim();
          if (!search) return true;
          const title = String(option?.title ?? "").toLowerCase();
          const value = String(option?.value ?? "").toLowerCase();
          return title.includes(search) || value.includes(search);
        }}
        dropdownRender={(menu) => (
          <>
            {newItemLabel && !disabled && (
              <div style={{ display: "flex", justifyContent: "center" }}>
                <span
                  onClick={onAddNew}
                  style={{
                    width: "100%",
                    cursor: "pointer",
                    padding: "8px 12px",
                    color: "#E36E00",
                    fontWeight: "500",
                    transition: "all 0.2s ease",
                    borderRadius: "4px",
                    margin: "4px 8px",
                  }}
                >
                  {newItemLabel}
                </span>
              </div>
            )}
            {menu}
          </>
        )}
      >
        {options &&
          options.length > 0 &&
          options.map((option, index) => (
            <Option
              key={`${option.id}-${dropdowType}`}
              value={option.id}
              style={{
                borderTop: `1px solid ${theme.colors.bordertask}`,
                borderRadius: "8px",
                cursor: "pointer",
                margin: "2px 8px",
                padding: "8px 12px",
                transition: "all 0.2s ease",
                zIndex: 2000,
              }}
              title={option.label}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                {option.icon && (
                  <span style={{ marginTop: "6px" }}>{option.icon}</span>
                )}
                {option.label}
              </div>
            </Option>
          ))}
      </Select>
    </ConfigProvider>
  );
};

export default DropdownWithSearch;
